/*============================================================================
  Cart shipping total
  ----------------------------------------------------------------------------
  Fills [data-cart-shipping] (in the cart drawer and the cart page) with the
  estimated total shipping for the cart, summed across delivery profiles by
  weight band. Uses window.BiriaShipping. Recalculates on cart changes.
==============================================================================*/
(function () {
  if (window.__cartShippingInit) return;
  window.__cartShippingInit = true;

  var S = window.BiriaShipping;
  if (!S) return;

  function format(dollars) {
    var cents = Math.round(dollars) * 100; // round to the nearest dollar
    if (window.theme && theme.Currency && theme.settings && theme.settings.moneyFormat) {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    }
    return '$' + Math.round(dollars).toLocaleString();
  }

  function render(cart) {
    var items = (cart && cart.items) || [];
    var total = S.cartTotal(items);
    document.querySelectorAll('[data-cart-shipping]').forEach(function (el) {
      el.textContent = format(total);
    });
    document.querySelectorAll('[data-cart-shipping-row]').forEach(function (row) {
      row.style.display = items.length ? '' : 'none';
    });
  }

  function fetchCart() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(render)
      .catch(function () {});
  }

  function start() {
    fetchCart();
    document.addEventListener('cart:updated', function (e) {
      if (e.detail && e.detail.cart) render(e.detail.cart); else fetchCart();
    });
    document.addEventListener('cart:build', fetchCart);
    // Add-to-cart (PDP, quick shop, etc.) fires this instead of cart:updated.
    // The response isn't the full cart, so re-fetch to recompute the total.
    document.addEventListener('ajaxProduct:added', fetchCart);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
